import moment from "moment";
import { assign, entries, pick } from "lodash";
import History from "@irati/utils/history";
import { ReportingSegmentOption } from "@irati/types";
export var generateSegmentOptions = function (segments, formatMessage) {
    return segments.map(function (segment) { return generateSegmentOption(segment, formatMessage); });
};
var generateSegmentOption = function (segment, formatMessage) {
    switch (segment) {
        case ReportingSegmentOption.PerkCategory:
            return { label: formatMessage({ id: "admin.reportingV3.segmentAndFilter.segment.perkCategory" }), value: segment };
        case ReportingSegmentOption.PerkType:
            return { label: formatMessage({ id: "admin.reportingV3.segmentAndFilter.segment.perkType" }), value: segment };
        case ReportingSegmentOption.PerkUuid:
            return { label: formatMessage({ id: "admin.reportingV3.segmentAndFilter.segment.perkUUID" }), value: segment };
        case ReportingSegmentOption.Team:
            return { label: formatMessage({ id: "admin.reportingV3.segmentAndFilter.segment.team" }), value: segment };
    }
};
var createDateDescription = function (_a, formatMessage) {
    var startDate = _a.startDate, endDate = _a.endDate, preset = _a.preset;
    if (preset) {
        return formatMessage({
            id: "admin.reportingV3.chartTitle." + preset
        });
    }
    else if (startDate && endDate) {
        var momentStart = moment(startDate);
        var momentEnd = moment(endDate);
        if (momentEnd.isSame(moment(), "d")) {
            return formatMessage({ id: "admin.reportingV3.chartTitle.dateSince" }, {
                date: momentStart.format("Do MMM YYYY")
            });
        }
        else {
            var startDateDisplay = void 0;
            var endDateDisplay = momentEnd.format("Do of MMM YYYY");
            if (momentStart.isSame(momentEnd, "y")) {
                if (momentStart.isSame(momentEnd, "M")) {
                    if (momentStart.isSame(momentEnd, "d")) {
                        return formatMessage({ id: "admin.reportingV3.chartTitle.dateOn" }, {
                            date: endDateDisplay
                        });
                    }
                    else {
                        startDateDisplay = momentStart.format("Do");
                    }
                }
                else {
                    startDateDisplay = momentStart.format("Do of MMMM");
                }
            }
            else {
                startDateDisplay = momentStart.format("Do of MMMM YYYY");
            }
            return formatMessage({ id: "admin.reportingV3.chartTitle.dateFromTo" }, {
                startDate: startDateDisplay,
                endDate: endDateDisplay
            });
        }
    }
    return "";
};
var getPercentChange = function (prev, curr, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 1; }
    return (((curr - prev) / prev) * 100).toFixed(decimalPlaces);
};
var getDateFormatForRange = function (startDate, endDate) {
    var diff = moment(endDate).diff(moment(startDate), "days");
    // these are arbitrary at the moment
    if (diff >= 366) {
        return "Do MMM YY";
    }
    if (diff > 170) {
        return "ddd, MMM D";
    }
    if (diff > 31) {
        return "Do MMM";
    }
    return "ddd Do MMM";
};
var formatDate = function (format) { return function (date) { return (date && moment(date).format(format)) || ""; }; };
export var ViewType;
(function (ViewType) {
    ViewType["GRAPH"] = "GRAPH";
    ViewType["TABLE"] = "TABLE";
})(ViewType || (ViewType = {}));
var searchToObject = function (search) {
    return search
        .replace(/^\?/, "")
        .split("&")
        .reduce(function (acc, curr) {
        var _a = curr.split("="), key = _a[0], value = _a[1];
        if (key && value)
            acc[key] = value;
        return acc;
    }, {});
};
var serialiseObject = function (filters) {
    return entries(filters)
        .map(function (keyValue) { return keyValue.join("="); })
        .join("&");
};
var addQueryToUrl = function (key, value) {
    var search = window.location.search;
    var searchObject = searchToObject(search);
    searchObject[key] = Array.isArray(value) ? value.join(",") : value;
    History.push({
        search: serialiseObject(searchObject)
    }, undefined, { scrollToTop: false });
};
var addQueriesToUrl = function (newSearchObject) {
    var search = window.location.search;
    var searchObject = searchToObject(search);
    var updatedObject = assign(searchObject, newSearchObject);
    History.push({
        search: serialiseObject(updatedObject)
    }, undefined, { scrollToTop: false });
};
var buildFiltersFromSearch = function (search, filters) {
    var searchObject = searchToObject(search);
    if (!filters)
        return searchObject;
    return pick(searchObject, filters);
};
var getDatesFromSearch = function (search) {
    var searchObject = searchToObject(search);
    return pick(searchObject, ["startDate", "endDate", "preset"]);
};
export { createDateDescription, getPercentChange, getDateFormatForRange, formatDate, addQueryToUrl, addQueriesToUrl, buildFiltersFromSearch, getDatesFromSearch, searchToObject };
